import React, { useEffect, useRef, useState } from "react"
import dayjs from "dayjs"
// import { ReactFullYearScheduler } from "react-full-year-scheduler"
import "react-full-year-scheduler/dist/style.css"
import axios from 'axios'
import QRCode from 'qrcode'
import moment from 'moment'
import { Helmet } from "react-helmet"
import '../Dashboard.css'
import '../styles/FmUx.css'
import { getFmSourceLabel } from '../utils/fmSource'

import Header from "../components/Header"
import Footer from "../components/Footer"
import ScrollToTop from "../components/ScrollTop"
import PreloadFetch from "../components/PreloadFetch"

import { ImCheckmark, ImCross, ImCalendar } from "react-icons/im"
import { useAuth } from '../provider/authProvider'
import { Link, useNavigate, useParams } from "react-router-dom"
import { ToastContainer, toast } from 'react-toastify'


const returnDateFormat = (dateOne) => {
    let splitDate = dateOne.split('/')
    let rebuildDate = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]

    return rebuildDate
}

const returnDateFormatTwo = (dateOne) => {
    let splitDate = dateOne.split('-')
    let rebuildDate = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]

    return rebuildDate
}


function CreditPage(props) {

    const { user } = useAuth()

    const navigate = useNavigate()

    const getParams = useParams()

    const [listCreditData, setListCreditData] = useState()

    const [listCreditDataLocation, setListCreditDataLocation] = useState()

    const [daysPayment, setDaysPayment] = useState()

    const [daysPaymentTwo, setDaysPaymentTwo] = useState()

    const [events, setEvents] = useState([])

    const [blockConfirmPay, setBlockConfirmPay] = useState(false)

    const [confirmPay, setConfirmPay] = useState(false)

    const [currentDate, setCurrentDate] = useState()

    const [preload, setPreload] = useState(false)

    const [stateDevice, setStateDevice] = useState(false)

    const [unlockCode, setUnlockCode] = useState('')

    const [allpayState, setAllpayState] = useState(false)

    const [urlQrCode, setUrlQrCode] = useState()

    const [structureCalendar, setStructureCalendar] = useState(-1)

    const [wrapDaysPayment, setWrapDaysPayment] = useState()

    const [payNow, setPayNow] = useState(0)

    const [dataNumbers, setDataNumbers] = useState()

    const [resumePayment, setResumePayment] = useState([])

    const [feeCount, setFeeCount] = useState(0)
    const [feePay, setFeePay] = useState(0)
    const [feeExpire, setFeeExpire] = useState(0)
    const [feePending, setFeePending] = useState(0)
    const [feePendingTotal, setFeePendingTotal] = useState(0)

    const [stateBlockDevice, setStateBlockDevice] = useState(null)
    const [stateFilter, setStateFilter] = useState(null)

    const [uploadName, setUploadName] = useState(null)

    const [uploadNameCartaCobranza, setUploadNameCartaCobranza] = useState(null)

    // const [uploadNameConstanciaNoAdeudo, setUploadNameConstanciaNoAdeudo] = useState(null)

    const [cartaCobranzaState, setCartaCobranzaState] = useState(false)

    const [cartaConstanciaState, setCartaConstanciaState] = useState(false)

    const [blockResquedulePay, setBlockResquedulePay] = useState(false)

    const [dayResquedule, setDayResquedule] = useState()

    const [selectClassName, setSelectClassName] = useState(-1)

    const refChangeNum = useRef()

    const refChangeNumTwo = useRef()

    const resqueduleNumFeeRef = useRef()

    const [resqueduleNumFee, setResqueduleNumFee] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9])

    const [countPaymentFalse, setCountPaymentFalse] = useState([])

    const [listResPayments, setListResPayments] = useState([])

    // 

    const pfArr = ['Semanal', 'Quincenal', 'Mensual'];
    const sourceLabel = listCreditData ? getFmSourceLabel(listCreditData.source) : 'Sin fuente';

    const changeDate = (date) => {
        let firtsPaymentTransformOne = date.split('/')
        let constructDate = firtsPaymentTransformOne[2] + '-' + firtsPaymentTransformOne[1] + '-' + firtsPaymentTransformOne[0]
        return constructDate
    }

    const getCreditData = async () => {
        try {
            setPreload(true)
            const credits = await axios({
                method: 'get',
                url: process.env.REACT_APP_API + '/fm/' + getParams.id,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    user
                }
            })
            const resData = credits.data
            // console.log(resData)
            setListCreditData(resData.data[0])

            setDaysPayment(resData.data[0] ? resData.data[0].daysPayment : '')

            setWrapDaysPayment(resData.data[0] ? resData.data[0].daysPayment : '')

            setDataNumbers(resData.dataNumbers)

            setResumePayment(resData.resumePayment)

            let dataWeekPay = JSON.parse(resData.data[0].daysPayment)

            setFeeCount(dataWeekPay.length)
            let feePay = dataWeekPay.filter(item => item.state == 1)
            let feeNotPay = dataWeekPay.filter(item => item.state == 0)

            //-----
            let arrFeeNotPay = []
            for (let i = 1; i <= feeNotPay.length; i++) {
                arrFeeNotPay.push(i)
            }
            setCountPaymentFalse(arrFeeNotPay)

            setListResPayments(resData.resPayments)

            setPreload(false)

            // setStateDevice(resData.data[0].stateBlockDevice == 1 ? true : false)
        } catch (err) {
            console.log(err)
            return false
        }
    }

    const changeEventsCalendar = () => {
        if (daysPayment) {
            let newArr = []
            let newObjFunc = (index, date, status) => {
                return {
                    eventName: "Pago " + index,
                    startDate: dayjs(date),
                    endDate: dayjs(date),
                    eventBgColor: status == 0 ? "#ff0000" : '#198754',
                    eventTextColor: "white"
                }
            }
            if (daysPayment) {
                JSON.parse(daysPayment).forEach((item, index) => {
                    // console.log(item.date)
                    return newArr.push(newObjFunc(index + 1, item.date, item.state))
                })
                setEvents(newArr)
            }
        }
    }

    const confirmChangePay = async () => {
        if (!confirmPay) {
            alert('Hace falta su confirmación de pagó')
            return false
        }

        let confirm = window.confirm('¿Confirmar Pago?')
        let newIndex = 0
        // console.log('frankkkkk')
        // console.log(daysPayment)
        // return false
        if (confirm) {
            let newDaysPayment = JSON.parse(daysPayment).map((item, index) => {
                // if (item.id !== 0) {
                if (item.state === 1) {
                    item.state = 1
                } else if (item.state === 0) {
                    // console.log('item up')
                    // console.log(item, currentDate[index])
                    // console.log('item.')
                    // console.log(JSON.stringify(item))
                    // console.log('newindex.')
                    // console.log(JSON.stringify(currentDate[newIndex]))

                    if (JSON.stringify(item) == JSON.stringify(currentDate[newIndex])) {
                        item.state = 1
                        // console.log('si')
                    }
                    newIndex++
                } else {
                    item.state = 0
                }
                return item
                // }
            })

            // console.log('current date')
            // console.log(newDaysPayment)

            setPreload(true)
            const insertNewDaysPayment = await axios({
                method: 'POST',
                url: process.env.REACT_APP_API + process.env.REACT_APP_UPDATE_FM_DATE_PAYMENT,
                data: { id: getParams.id, newDaysPayment },
                withCredentials: "true",
                credentials: 'include'
            })
            const resData = insertNewDaysPayment.data
            // console.log(resData)
            if (resData.msg == 'success') {
                setDaysPayment(resData.data.newDaysPayment)
                // setWrapDaysPayment(resData.data)
                // setDaysPaymentTwo(resData.dataTwo)
                // console.log(resData.dataTwo)
                // setStructureCalendar('1')
                // if (structureCalendar == 0) {
                // setWrapDaysPayment(resData.data)
                setBlockConfirmPay(false)
                setConfirmPay(false)
                setPreload(false)
                // window.rea
                alert('Se actualizó las fechas de pagó con éxito!')
                location.reload()
            } else {
                alert('Error')
            }
        } else {
            setBlockConfirmPay(false)
            setConfirmPay(false)
        }
    }

    //show popup for payment confirm
    const paymentConfirm = async (eventDate) => {
        // alert('Hola Pago')
        // return false
        // console.log(daysPayment)
        setCurrentDate([])
        const getEventDay = dayjs(eventDate).format("YYYY-MM-DD")
        // console.log(getEventDay)
        // // console.log(JSON.parse(daysPayment))
        // console.log('datossss')
        // console.log(returnDateFormat(eventDate))
        // return false
        // console.log(moment(returnDateFormat(eventDate)).format())
        // console.log(moment(returnDateFormat(el.date)).format())
        const days = JSON.parse(daysPayment) || []

        const filterReturn = days.filter(
            el => el.state == 0 && moment(returnDateFormat(el.date)).format() <= moment(returnDateFormat(eventDate)).format()
        )
        const mapReturn = days.filter(el => el.state === 0)

        if (filterReturn.length > 0) {
            // console.log('filter')
            // return false
            setBlockConfirmPay(true)
            setCurrentDate(filterReturn)
            // console.log(filterReturn)
            // return false
        }
    }

    const goOutPopup = () => {
        setBlockConfirmPay(false)
        setBlockResquedulePay(false)
    }

    const getStatedevice = async () => {
        let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_DEVICE_DETAILS
        // console.log(pathApi)
        let dataID = getParams.id

        const stateDevice = await axios({
            method: 'POST',
            url: pathApi,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                user,
                'Content-Type': 'application/json',
            },
            data: { dataID }
        })
        // console.log(insertCredit)
        const resData = stateDevice.data
        // console.log(resData)
        if (resData.msg == 'exito') {
            // console.log('exito')
            setStateDevice(resData.statusLock)
            setUnlockCode(resData.unlockCode)
        }
    }

    // bloquear dispositivo
    const blockAction = async () => {
        let confirm = window.confirm('¿Confirmar Acción?')
        if (confirm && !stateDevice) {
            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_CONTROL_DEVICE

            let dataID = getParams.id
            let stateBlockDevice = stateDevice

            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: { dataID, stateBlockDevice },
                withCredentials: false,
                credentials: 'include'
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'exito') {
                console.log('exito')
                // setStateDevice(stateDevice?false:true)
                setStateDevice(stateDevice ? false : true)
            }
        }
    }

    const overDates = (v, ind) => {
        // console.log(arr)
        // console.log(i)
        let listArr = document.querySelectorAll('.datesPaymentItems')
        // console.log(listArr)
        Array.from(listArr).map(function(ele, index, arr) {
            ele.classList.remove('active');
            // if( ele.classList.contains('select') ){
            for (let i = 0; i <= ind; i++) {
                arr[i].classList.add('active');
                // textActive.innerHTML = states[ind];
            }
            return false
            // }
        })
    }

    const outDates = (v, ind) => {
        // console.log(arr)
        // console.log(i)
        let listArr = document.querySelectorAll('.datesPaymentItems')
        // console.log(listArr)
        Array.from(listArr).map(function(ele, index, arr) {
            ele.classList.remove('active')
            // if( ele.classList.contains('select') ){
            // }
        })
    }

    const paymentAll = async (calendarDays) => {
        let confirm = window.confirm('¿Confirmar Pagó Total del dispositivo y liberación de APP de seguridad?')
        if (confirm) {
            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_UNREGISTER_DEVICE

            let dataID = getParams.id
            let stateBlockDevice = stateDevice
            // console.log(days)
            // console.log('franl')
            // return false
            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: { dataID, calendarDays },
                withCredentials: false,
                credentials: 'include'
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'exito') {
                console.log('exito')
                setStateDevice(stateDevice ? false : true)
                setTimeout(() => {
                    location.reload()
                }, 250)
            }
        }
    }

    const generateQR = async text => {
        return await QRCode.toDataURL(text, { errorCorrectionLevel: 'H' })
    }

    const changeStructureCalendar = (v) => {
        // console.log(v)
        console.log(structureCalendar)
        setStructureCalendar(v)

        if (structureCalendar == 1) {
            // console.log(daysPaymentTwo)
            // setStructureCalendar(1)
            setWrapDaysPayment(daysPaymentTwo)
            // setStructureCalendar(v)
            console.log('dos')
            // setStructureCalendar(1)
            // return false
        }

        if (structureCalendar == 0) {
            // setStructureCalendar(0)
            setWrapDaysPayment(daysPayment)
            console.log('uno')
            // return false
        }

    }

    const recoverFiles = async () => {
        let confirm = window.confirm('¿Confirmar que desea recuperar los archivos?')
        if (confirm) {
            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_RECOVER_FILES
            let dataID = getParams.id
            let stateBlockDevice = stateDevice
            // console.log(days)
            // console.log('franl')
            // return false
            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    'Content-Type': 'application/json',
                },
                data: { dataID }
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'success') {
                console.log('exito')
                console.log(resData)
            }
        }
    }

    const recoverCartaCobranza = async () => {
        let confirm = window.confirm('¿Generar carta de cobranza?')
        // return false
        if (confirm) {
            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_RECOVER_CARTA_COBRANZA
            let dataID = getParams.id
            let stateBlockDevice = stateDevice
            // console.log(days)
            // console.log('franl')
            // return false
            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    'Content-Type': 'application/json',
                },
                data: { dataID }
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'success') {
                console.log('exito')
                console.log(resData)
                // cartaCobranzaState()
                setCartaCobranzaState(true)
            }
        }
    }

    const recoverConstanciaNoAdeudo = async () => {
        let confirm = window.confirm('¿Generar constancia de no adeudo?')
        // return false
        if (confirm) {
            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_RECOVER_CONTANCIA_NO_ADEUDO
            let dataID = getParams.id
            let stateBlockDevice = stateDevice
            // console.log(days)
            // console.log('franl')
            // return false
            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    'Content-Type': 'application/json',
                },
                data: { dataID }
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'success') {
                console.log('exito')
                console.log(resData)
                // cartaCobranzaState()
                // setCartaCobranzaState(true)
                setCartaConstanciaState(true)
            }
        }
    }

    const validateDate = () => {
        try {
            let status = false
            if (daysPayment && daysPayment.length > 10) {
                let feeOne = JSON.parse(daysPayment)[0].cuota_final
                let feeTwo = JSON.parse(daysPayment)[1].cuota_final
                if (feeOne == feeTwo) status = true
            }
            return status
        } catch (e) {
            console.log(e)
        }
    }

    const doDayResquedule = (num, date) => {
        console.log(date)
        setDayResquedule(date)
        setSelectClassName(num)
    }

    const confirmResquedule = async () => {
        if (dayResquedule == null) {
            alert('Selecciónar fecha a reprogramar.')
            return false
        }
        if (resqueduleNumFeeRef.current.value == null || resqueduleNumFeeRef.current.value == 0) {
            alert('Selecciónar número de cuotas a pagar.')
            return false
        }

        let listPayment = JSON.parse(daysPayment)
        let listPaymentsTrue = listPayment.filter(item => item.state == 1)
        let listPaymentsFalse = listPayment.filter(item => item.state == 0)
        let listPaymentsFalseCount = listPaymentsFalse.length
        let endComplement = []
        // console.log(listPaymentsTrue)
        // console.log('si')
        // console.log(listPaymentsFalse)
        // return false
        // console.log('total de cuotas por pagar')
        let newNumFee = resqueduleNumFeeRef.current.value
        let paymentFrequency = listCreditData.paymentFrequency
        // return false

        if (paymentFrequency == 'Semanal') {
            let numDays = 7
            for (let i = 1; i <= listPaymentsFalse.length; i++) {
                let setWeeksDays = moment(returnDateFormatTwo(dayResquedule)).add(i * numDays, 'days')
                let weeksDays = setWeeksDays.format('DD/MM/YYYY')

                listPaymentsFalse[i - 1].date = weeksDays
                listPaymentsFalse[i - 1].state = 0

                if (i - 1 <= newNumFee - 1) {
                    listPaymentsFalse[i - 1].state = 1
                }
            }
            // console.log('mm')
            endComplement = listPaymentsFalse.filter((el, i) => el.date = moment(returnDateFormat(el.date)).subtract(1 * numDays, 'days').format('DD/MM/YYYY'))
            // console.log(restListPaymentFalse)

        } else if (paymentFrequency == 'Quincenal') {
            let numDays = 15
            for (let i = 1; i <= listPaymentsFalse.length; i++) {
                let setWeeksDays = moment(returnDateFormatTwo(dayResquedule)).add(i * numDays, 'days')
                let weeksDays = setWeeksDays.format('DD/MM/YYYY')

                listPaymentsFalse[i - 1].date = weeksDays
                listPaymentsFalse[i - 1].state = 0

                if (i - 1 <= newNumFee - 1) {
                    listPaymentsFalse[i - 1].state = 1
                }
            }
            endComplement = listPaymentsFalse.filter((el, i) => el.date = moment(returnDateFormat(el.date)).subtract(1 * numDays, 'days').format('DD/MM/YYYY'))
        } else {

        }

        // console.log('abcdefg')
        // console.log(newNumFee)
        let newDateLock = listPaymentsFalse[parseInt(newNumFee) - 1]

        let newDaysPayment = listPaymentsTrue.concat(endComplement)
        console.log('CRONOGRAMA DE CRÉDITO')
        console.log(newDaysPayment)
        // return false
        let confirm = window.confirm('¿Confirmar Reprogramación de calendario?')
        let newIndex = 0
        // console.log(daysPayment)
        // return false
        if (confirm) {
            setPreload(true)
            const insertNewDaysPayment = await axios({
                method: 'POST',
                url: process.env.REACT_APP_API + process.env.REACT_APP_RESCHEDULING_PAYMENTS,
                data: { id: getParams.id, newDaysPayment, listPaymentsFalseCount, newDateLock },
                withCredentials: "true",
                credentials: 'include'
            })
            const resData = insertNewDaysPayment.data
            // console.log(resData)
            if (resData.msg == 'success') {
                setDaysPayment(resData.data.newDaysPayment)
                // setDaysPaymentTwo(resData.data.newDaysPaymentTwo)
                setPreload(false)
                setBlockResquedulePay(false)
                // window.rea
                alert('Se reprogramó las fechas de pagó con éxito!')
                location.reload()
            } else {
                alert('Error')
            }
        } else {
            setBlockResquedulePay(false)
        }
    }

    const timePay = (frequency, numFee) => {
        let res = 0
        let period = ''
        if (frequency == 1) {
            res = numFee / 4
        } else if (frequency == 2) {
            res = numFee / 2
        } else {
            res = numFee / 1
        }

        if (res <= 1) period = 'Mes'
        else period = 'Meses'

        return res + ' ' + period
    }

    useEffect(() => {
        changeEventsCalendar()
    }, [daysPayment])


    useEffect(() => {
        getCreditData()
        getStatedevice()
    }, [])


    return (
        <div>
            {
                preload && (
                    <PreloadFetch />
                )
            }
            <ScrollToTop />
            <Header user={user} namePage={props.namePage} />
            <section className="sectionBody sectionBodyCredit sectionBodyFmPage">
                <div className="containerCustom containerBody">
                    {
                        listCreditData && (
                            <div className="blockBody fmUxDetail">
                                <div className="fmUxDetailHeader"><div><span className="fmUxEyebrow">Detalle de financiamiento mixto</span><h3>{listCreditData.fullName + ' ' + listCreditData.lastName}</h3><p>DNI {listCreditData.dni} · {listCreditData.phoneName}</p></div><span className={`fmUxSource fmUxSource--${String(listCreditData.source || 'unknown')}`}>{sourceLabel}</span></div>
                                <div className="parentData parentDataFirst">

                                    <div className="blockLoanCalculation">
                                        <h3 className="fs-5">INFORMACIÓN PERSONAL</h3>
                                        <div className="listLoanCalculation">
                                            <div>
                                                <span className="loadTitle">Nombre Completo:</span>
                                                <span className="loanPrice">{listCreditData.fullName + ' ' + listCreditData.lastName}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Documento de Identidad:</span>
                                                <span className="loanPrice">{listCreditData.dni}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Email:</span>
                                                <span className="loanPrice">{listCreditData.email}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Número de Celular:</span>
                                                <span className="loanPrice">{listCreditData.phoneNumber}</span>
                                            </div>

                                            {/* <div className="parentDniBlock">
                                                <span className="loadTitle">DNI parte frontal:</span>
                                                <span className="loanPrice parentDni"><img src={process.env.REACT_APP_API + '/data-files-or/' + listCreditData.uploadName + '/' + listCreditData.dniFront} /></span>
                                            </div>
                                            <div className="parentDniBlock">
                                                <span className="loadTitle">DNI parte trasera:</span>
                                                <span className="loanPrice parentDni"><img src={process.env.REACT_APP_API + '/data-files-or/' + listCreditData.uploadName + '/' + listCreditData.dniBack} /></span>
                                            </div> */}

                                        </div>
                                    </div>

                                    <div className="blockLoanCalculation">
                                        <h3 className="fs-5">INFORMACIÓN DEL EQUIPO</h3>
                                        <div className="listLoanCalculation">
                                            <div>
                                                <span className="loadTitle">Nombre del Equipo:</span>
                                                <span className="loanPrice">{listCreditData.phoneName}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">IMEI:</span>
                                                <span className="loanPrice">{listCreditData.imei}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="blockLoanCalculation">
                                        <h3 className="fs-5">INFORMACIÓN FINANCIERA:</h3>
                                        <div className="listLoanCalculation">
                                            <div>
                                                <span className="loadTitle">Fecha de contrato:</span>
                                                <span className="loanPrice">{listCreditData.contractDate}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Fuente:</span>
                                                <span className="loanPrice">{sourceLabel}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Monto total FM:</span>
                                                <span className="loanPrice">S/ {parseFloat(listCreditData.amount).toFixed(2)}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Cuota {sourceLabel}:</span>
                                                <span className="loanPrice">S/ {parseFloat(listCreditData.amountSource).toFixed(2)}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Cuota FM:</span>
                                                <span className="loanPrice">S/ {parseFloat(listCreditData.fee).toFixed(2)}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Cuota {sourceLabel} + FM:</span>
                                                <span className="loanPrice">S/ {(Number(listCreditData.amountSource) + Number(listCreditData.fee)).toFixed(2)}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Frecuencia de Pago:</span>
                                                <span className="loanPrice">{pfArr[listCreditData.paymentFrequency - 1]}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Número de Pagos:</span>
                                                <span className="loanPrice">{listCreditData.numFee}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Tiempo total de pagó:</span>
                                                <span className="loanPrice">{timePay(listCreditData.paymentFrequency, listCreditData.numFee)}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="blockLoanCalculation">
                                        <h3 className="fs-5">INFORMACIÓN DE UBICACIÓN Y DIRECCIÓN:</h3>
                                        <div className="listLoanCalculation">
                                            <div>
                                                <span className="loadTitle">Dirección:</span>
                                                <span className="loanPrice">{listCreditData.direc}</span>
                                            </div>
                                        </div>
                                    </div>



                                </div>

                                {
                                    listCreditDataLocation && (
                                        <>
                                            <div className="blockLocationData">
                                                <h3 className="fs-5">INFORMACIÓN DE UBICACIÓN DEL CLIENTE:</h3>
                                                <div className="listLoanCalculation">
                                                    <div>
                                                        <span className="loadTitle">Dirección:</span>
                                                        <span className="loanPrice">{listCreditDataLocation.direc}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }

                                {
                                    stateBlockDevice == '3' && (
                                        <div className="controlBarWrapper">
                                            <div className="controlBar">
                                                <h3>CONSTANCIA DE NO ADEUDO</h3>
                                                {/* <div>
                                                    <a href={uploadName} download={true} target="_blank" className="controlBarButtonAction controlBarButtonActionActive">GENERAR CONSTANCIA</a>
                                                </div> */}

                                                <div>
                                                    <button onClick={recoverConstanciaNoAdeudo} className="controlBarButtonAction controlBarButtonActionActive">GENERAR CONSTANCIA</button>
                                                    {
                                                        cartaConstanciaState && (
                                                            <a href={uploadName} download={true} target="_blank" className="controlBarButtonAction controlBarButtonActionActive">DESCARGAR</a>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }


                                <div className="parentCalendar">
                                    <h3 className="fs-5 titleCalendar">CALENDARIO DE PAGOS:</h3>
                                </div>

                                {
                                    resumePayment && resumePayment.length > 0 && (
                                        <div className="parentData resumePayment">
                                            <div>
                                                <h3 className="fs-5 titleDatePayment">RESUMEN DE PAGOS</h3>

                                                <div className="listLoanCalculation datesPayments datesPaymentsHead">
                                                    <div className="tableFinancialHead">
                                                        <span>CUOTA</span>
                                                        <span>SELLER</span>
                                                        <span>CANTIDAD DE CUOTAS</span>
                                                        <span>MONTO DE CUOTA</span>
                                                        <span>FECHA VENCIMIENTO</span>
                                                        <span>FECHA PAGÓ</span>
                                                    </div>
                                                </div>

                                                <div className="listLoanCalculation datesPayments WrapperDatesPayments">
                                                    {
                                                        resumePayment && resumePayment.map((item, index) => {
                                                            const nFees = Number(item?.fmp_num_fee_paid || 1);
                                                            const isProntoPago = nFees > 1;

                                                            const paidFee = Number(item?.fmp_fee ?? 0);

                                                            let fallbackCuota = 0;
                                                            try {
                                                                const dp = JSON.parse(wrapDaysPayment || '[]');
                                                                fallbackCuota = Number(dp?.[0]?.cuota ?? 0);
                                                            } catch {}

                                                            const feeToShow = paidFee > 0 ? paidFee : fallbackCuota;

                                                            return (
                                                                <div key={index}>
                                                                    <span>{index + 1}</span>
                                                                    <span>{item?.seller_name || '-'}</span>
                                                                    <span>{isProntoPago ? `${nFees}` : '1'}</span>
                                                                    <span className="loanPrice">S/ {Number(feeToShow).toFixed(2)}</span>
                                                                    <span>{item?.fmp_expire}</span>
                                                                    <span>{item?.fmp_current_date}</span>
                                                                </div>
                                                            );
                                                        })

                                                    }
                                                </div>

                                                {/* <div className="resumePaymentDetail">
                                                    CANTIDAD DE CUOTAS: <strong>{feeCount}</strong> | 
                                                    CUOTAS PAGADAS: <strong>{feePay}</strong> | 
                                                    CUOTAS VENCIDAS: <strong>{feeExpire}</strong> | 
                                                    CUOTAS PENDIENTES: <strong>{feePendingTotal}</strong>
                                                </div> */}
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="parentData parentDataPaymentDate">
                                    <div>
                                        <h3 className="fs-5 titleDatePayment">FECHAS DE PAGO</h3>

                                        <div className="financialCreditData">
                                            <div>
                                                <div className="itemSigno">S/.</div>
                                                <div className="itemData">
                                                    <span className="itemOne">Financiamiento</span>
                                                    <span className="itemTwo">{parseFloat(listCreditData.amount).toFixed(2)}</span>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="itemSigno itemHeadDate">
                                                    <ImCalendar />
                                                </div>
                                                <div className="itemData">
                                                    <span className="itemOne">Plazo</span>
                                                    <span className="itemTwo">{timePay(listCreditData.paymentFrequency, listCreditData.numFee)}</span>
                                                </div>
                                            </div>

                                            {/* <div>
                                                <div className="itemSigno itemTotalAmount2">S/.</div>
                                                <div className="itemData">
                                                    <span className="itemOne">Monto Actual a pagar</span>
                                                    <span className="itemTwo"></span>
                                                </div>
                                            </div> */}

                                            <div>
                                                <div className="itemSigno itemTotalAmount">S/.</div>
                                                <div className="itemData">
                                                    <span className="itemOne">Total a pagar</span>
                                                    <span className="itemTwo">{parseFloat(listCreditData.amount).toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </div>


                                        {
                                            localStorage.getItem('user') !== 'creditosycobranzas.movilpro@gmail.com' ?
                                                <div className="buttonsChangeTime">
                                                    <div onClick={() => changeStructureCalendar(0)} className={structureCalendar == 0 ? 'select' : ''}>{pfArr[listCreditData.paymentFrequency - 1]}</div>
                                                </div>
                                                :
                                                <div className="buttonsChangeTime">
                                                    <div className={structureCalendar == 0 ? 'select' : ''}>{listCreditData.paymentFrequency}</div>
                                                </div>
                                        }


                                        <div className="listLoanCalculation datesPayments datesPaymentsHead">
                                            <div className="tableFinancialHead">
                                                <span>#</span>
                                                <span>ESTADO</span>
                                                <span>VENCIMIENTO</span>
                                                <span>CUOTA</span>
                                                <span>SALDO</span>
                                            </div>
                                        </div>
                                        <div className="listLoanCalculation datesPayments WrapperDatesPayments">


                                            <div>
                                                <span>#</span>
                                                <span>---</span>
                                                <span>---</span>
                                                <span>---</span>
                                                <span>S/ {parseFloat(listCreditData.amount).toFixed(2)}</span>
                                            </div>


                                            {
                                                wrapDaysPayment && JSON.parse(wrapDaysPayment).map((item, index, arr) => {
                                                    // console.log(item)
                                                    // if( item.id !== 0 ){
                                                    let styleComision = {}
                                                    let selectItem = ''
                                                    let comision2State = ''

                                                    if (item.id !== 0) {
                                                        if (item.comision !== '' && item.comision != null) {
                                                            styleComision = { backgroundColor: 'lightgreen', fontWeight: 700 }
                                                        }

                                                        if (
                                                            item.state === 0 &&
                                                            moment(returnDateFormat(item.date)).isSame(moment().format("YYYY-MM-DD"))
                                                            || moment(moment().format("YYYY-MM-DD")).isAfter(returnDateFormat(item.date))) {
                                                            selectItem = 'select'
                                                        }

                                                        if (item.date == moment().format("DD/MM/YYYY")) {
                                                            selectItem = 'select now'
                                                        }
                                                    }

                                                    return <div
                                                        className={"datesPaymentItems " + selectItem}
                                                        key={index}
                                                        onMouseOut={(event) => outDates(event.target, index)}
                                                        onMouseOver={(event) => overDates(event.target, index)}>
                                                        <span>{index + 1 + '.'}</span>
                                                        {/* {
                                                            item.state === 0 && item.date !== null && (
                                                                <span className="loanPrice htmlPaymentState" onClick={() => structureCalendar == 0 ? paymentConfirm(item.date) : alert('Accción no permitido')}><strong>PENDIENTE</strong></span>
                                                            )
                                                        } */}
                                                        {
                                                            item.state === 0 && item.date !== null && (
                                                                <span className="loanPrice htmlPaymentState"><strong>PENDIENTE</strong></span>
                                                            )
                                                        }
                                                        {
                                                            item.state === 1 && item.date !== null && (
                                                                <span className="loanPrice htmlPaymentState htmlPaymentState1"><strong>CANCELADO</strong></span>
                                                            )
                                                        }
                                                        {
                                                            item.state === 0 && item.date == null && (
                                                                <span>---</span>
                                                            )
                                                        }
                                                        <span className="loadTitle">{item.date == null ? '---' : item.date}</span>
                                                        <span className="loanPrice">{item.cuota == null ? '---' : 'S/ ' + parseFloat(item.cuota).toFixed(2)}</span>
                                                        <span>S/ {parseFloat(item.saldo).toFixed(2)}</span>
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        )
                    }
                </div>
            </section>
            {
                blockConfirmPay && (
                    <div className="popupConfirmPayment">
                        <div className="popupConfirmPayment_wrapper">
                            <div className="popupGoOut" onClick={() => goOutPopup()}><ImCross /></div>
                            <div className="popupConfirmPayment_content">
                                <h4>Confirmar Pago</h4>
                                <h5 className="popupConfirmPayment_subtitle">Al hacer click en el cuadro estas confirmando la verificación del pago.</h5>

                                <div className="checkConfirmPay" onClick={(e) => setConfirmPay(true)}>
                                    {
                                        confirmPay && (
                                            <div><ImCheckmark /></div>
                                        )
                                    }
                                </div>
                                <button className="buttonConfirmPay" onClick={confirmChangePay} >Confirmar</button>
                            </div>
                        </div>
                    </div>
                )
            }
            <Footer />

            {
                blockResquedulePay && (
                    <div className="popupConfirmPayment">
                        <div className="popupConfirmPayment_wrapper">
                            <div className="popupGoOut" onClick={() => goOutPopup()}><ImCross /></div>

                            <div className="popupConfirmPayment_content">
                                <h4>Confirmar Reprogramación de Pago</h4>
                                <h5 className="popupConfirmPayment_subtitle">Selecciónar día para reprogramación del calendario:</h5>

                                <div className="resqueduleDaysList">
                                    <div className={selectClassName == 0 ? 'active' : ''} onClick={() => doDayResquedule(0, moment().format("DD-MM-YYYY"))}>
                                        {moment().format("DD-MM-YYYY")} - <span>Hoy</span>
                                    </div>
                                    <div className={selectClassName == 1 ? 'active' : ''} onClick={() => doDayResquedule(1, moment().add(1, 'days').format("DD-MM-YYYY"))}>
                                        {moment().add(1, 'days').format("DD-MM-YYYY")} - <span>{moment().add(1, 'days').format('dddd')}</span>
                                    </div>
                                </div>

                                <h5 className="popupConfirmPayment_subtitle">Selecciónar número de cuotas a pagar:</h5>

                                <div className="resqueduleDaysList">
                                    <select
                                        // onChange={(e) => resqueduleNumFeeChange(e)}
                                        // options={paymentFrequencyArr}
                                        // autoFocus={true}
                                        className="selectForm formItem selectResNumFee"
                                        name=""
                                        id="paymentFrequency"
                                        ref={resqueduleNumFeeRef}
                                    >
                                        {
                                            countPaymentFalse.map((item, index) => {
                                                // console.log(item)
                                                return <option key={'fp' + index} value={item}>{item}</option>
                                            })
                                        }
                                    </select>
                                </div>

                                <button className="buttonConfirmPay" onClick={confirmResquedule}>Confirmar</button>
                            </div>

                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default CreditPage
